import { getAuthHeaders } from '../actions/authActions';
import tempMeeApi from '../apis/tempMee';

export const fetchOnsiteInterviews = async (postingId, filters = {}) => {
  const headers = await getAuthHeaders();

  const params = {
    page: filters?.page || 1,
    limit: filters?.limit || 15,
    orderBy: filters?.sortField || 'created',
    orderDirection: filters?.sortOrder || 'desc',
  };

  if (filters?.status && filters.status !== 'all') {
    params.status = filters.status;
  }

  const response = await tempMeeApi.get(
    `/admin/postings/${postingId}/onsite-interviews`,
    { headers, params },
  );

  return response.data;
};

// eslint-disable-next-line arrow-body-style
export const createOnsiteInterview = async (jobId, payload) => {
  return { success: true, jobId, payload };
};
